import { Icon as PickuppIcon } from '@pickupp/ui/core'
import {
  Facebook,
  Instagram,
  LinkedIn,
} from '@pickupp/ui/icons'
import PropTypes from 'prop-types'
import React from 'react'

const socialIcons = {
  facebook: <Facebook />,
  linkedin: <LinkedIn />,
  instagram: <Instagram />,
}

const Icon = ({
  icon,
  image,
  className,
}) => {
  if (icon?.name && socialIcons[icon?.name]) {
    return socialIcons[icon?.name]
  }

  if (!image && !icon) return null

  if (icon) {
    return (
      <PickuppIcon
        name={icon.name}
        className={className}
        vendor={icon.vendor}
        type={icon.type}
      />
    )
  }

  return (
    <img
      loading="lazy"
      className={className}
      src={image?.src?.data?.attributes?.url}
      alt={image?.alt || ''}
    />
  )
}

Icon.propTypes = {
  icon: PropTypes.object,
  image: PropTypes.object,
  className: PropTypes.string,
}

Icon.defaultProps = {
  icon: null,
  image: null,
  className: null,
}

export default Icon
